import request from '@/utils/request'

export default {
    // 客户案例
    index: params => {
        return request({
            url: '/company/case',
            method: 'GET',
            params
        })
    },
    // 客户案例详情
    detail: params => {
        return request({
            url: '/index/Info',
            method: 'GET',
            params
        })
    },
    // 客户列表
    aboutlist: params => {
        return request({
            url: '/consult/List',
            method: 'POST',
            params
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/case.js